import api from "./api";
import axios from "axios";

class AttivitaTimesheetManager {
    attivitaList(config?: any) {
        return api.get(`/attivita_timesheet/`, config)
    }

    attivita(attivita_timesheet_id: number | string, config?: any) {
        return api.get(`/attivita_timesheet/${attivita_timesheet_id}`, config)
    }

    retrieve = this.attivita
    list = this.attivitaList

}

const attivitaTimesheetManager = new AttivitaTimesheetManager()

export default attivitaTimesheetManager

